<template>
    <div class="page-table haberTanim mainDiv listPage" id="affix-container">
        <div style="margin-top: 10px" class="card-base baslikBg animated fadeInUp">Pop-up Listesi</div>
        <div class="page-header card-base card-shadow--medium animated fadeInUp">
            <el-col :span="23">
                <div>
                    <el-radio-group size="mini" v-on:change="handleChange($event)" v-model="radio" fill="#E5F5F9"
                                    text-color="gray">
                        <el-radio-button label="1">
                            <i class="mdi mdi-bell-alert mdi-18px" style="color: #13ce66; margin-right: 5px"></i>
                            <transition
                                    name="slide-fade"><label v-if="selectIcon==='1'">{{$t("src.views.apps.popup.liste.yayinda")}}</label>
                            </transition>
                        </el-radio-button>
                        <el-radio-button label="0">
                            <i class="mdi mdi-bell-alert mdi-18px" style="color: #ec205f; margin-right: 5px"></i>
                            <transition
                                    name="slide-fade"><label v-if="selectIcon==='0'">{{$t("src.views.apps.popup.liste.taslak")}}</label>
                            </transition>
                        </el-radio-button>
                    </el-radio-group>
                </div>
            </el-col>
            <el-col :span="1">
                <el-tooltip :content='$t("src.views.apps.popup.tanimlama.title")'
                            :open-delay="500"
                            placement="bottom">
                    <el-button
                            v-on:click="routePop('Popup Tanımla')"
                            style="float: right"
                            size="mini"
                            icon="el-icon-plus">
                    </el-button>
                </el-tooltip>
            </el-col>
            <el-table
                    :data="popupListe"
                    ref="filterTable"
                    style="width: 100%">
                <el-table-column
                        prop="baslik"
                        label="Başlık"
                        width="auto">
                </el-table-column>
                <el-table-column
                        prop="baslamaTarihi"
                        label="Başlama Tarihi"
                        width="auto">
                </el-table-column>
                <el-table-column
                        prop="bitisTarihi"
                        label="Bitiş Tarihi"
                        width="auto">
                </el-table-column>
                <el-table-column
                        label="İşlem"
                        align="right"
                        width="auto">
                    <template slot-scope="scope">
                        <el-tooltip :content='$t("src.views.apps.popup.liste.duzenle")'
                                    :open-delay="500"
                                    placement="bottom">
                            <el-button
                                    v-if="root || yetkiList.popupDuzenleme"
                                    v-on:click="routePop('Popup Düzenle',scope.row)"
                                    type="text"
                                    class="buttonEdit"
                                    icon="el-icon-edit">
                            </el-button>
                        </el-tooltip>
                        <el-tooltip :content='$t("src.views.apps.popup.liste.pasif")' :open-delay="500"
                                    placement="bottom">
                            <el-button
                                    v-if="selectIcon==='1' && (root || yetkiList.popupDurumGuncelle)"
                                    @click="deleteDialogVisible = true; selection = scope.row; selectionIndex = scope.$index"
                                    class="buttonDel"
                                    type="text"
                                    icon="mdi mdi-pause mdi-24px">
                            </el-button>
                        </el-tooltip>
                        <el-tooltip :content='$t("src.views.apps.popup.liste.pasif")' :open-delay="500"
                                    placement="bottom">
                            <el-button
                                    v-if="selectIcon==='0' && (root || yetkiList.popupDurumGuncelle)"
                                    @click="addDialogVisible = true; selection = scope.row; selectionIndex = scope.$index"
                                    type="text"
                                    icon="mdi mdi-play mdi-24px">
                            </el-button>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                    background
                    layout="sizes,prev, pager, next, jumper, total"
                    :total="total"
                    @size-change="handleSizeChange"
                    @current-change="pageChange"
                    :page-sizes="[10, 20, 50, 100]"
                    :current-page.sync="page"
                    :next-click.sync="page"
                    :prev-click.sync="page"
                    @next-click="pageChange"
                    @prev-click="pageChange">
            </el-pagination>
        </div>
        <el-dialog
                :title='$t("src.views.apps.popup.liste.uyari")'
                :visible.sync="deleteDialogVisible"
                width="30%"
                center>
            <span>"{{selection.baslik}}" {{$t('src.views.apps.popup.liste.pasifecek')}}</span>
            <span slot="footer" class="dialog-footer">
                    <el-button icon="el-icon-check"
                               type="success"
                               size="mini"
                               @click="changePopDurum(selection,selectionIndex,'0'), deleteDialogVisible = false"></el-button>
                    <el-button size="mini" type="danger" icon="el-icon-close"
                               @click="deleteDialogVisible = false"></el-button>
                </span>
        </el-dialog>
        <el-dialog
                :title='$t("src.views.apps.popup.liste.uyari")'
                :visible.sync="addDialogVisible"
                width="30%"
                center>
            <span>"{{selection.baslik}}" {{$t('src.views.apps.popup.liste.yayinaal')}}</span>
            <span slot="footer" class="dialog-footer">
                    <el-button icon="el-icon-check"
                               type="success"
                               size="mini"
                               @click="changePopDurum(selection,selectionIndex,'1'), addDialogVisible = false"></el-button>
                    <el-button size="mini" type="danger" icon="el-icon-close"
                               @click="addDialogVisible = false"></el-button>
                </span>
        </el-dialog>
    </div>
</template>

<script>
    import popupService from '../../../WSProvider/PopService'
    import notification from '../../../notification'

    let base64 = require('base64_js');
    let userDataSidas = "";
    export default {
        name: "PopupListe",
        mounted() {
            let self = this;
            if (localStorage.getItem("userDataSidas")) {
                userDataSidas = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataSidas"))));
                if (userDataSidas["tur"]) {
                    if (userDataSidas["tur"] === '1' || userDataSidas["tur"] === '2') {
                        self.root = true;
                        self.yetkiList.popupDuzenleme = true;
                        self.yetkiList.popupDurumGuncelle = true;
                    }
                } else if (userDataSidas["yetki"]) {
                    userDataSidas["yetki"].forEach(function (value) {
                        switch (value.yetkiKodu) {
                            case 'YK-795990':
                                self.yetkiList.popupDuzenleme = true;
                                self.yetkiList.popupDurumGuncelle = true;
                                break;
                            case 'YK-470160':
                                self.yetkiList.popupDurumGuncelle = true;
                                break;
                        }
                    });
                }
            }
            this.getPopupListe();
        },
        data() {
            return {
                selectIcon: '1',
                radio: '1',
                root: false,
                yetkiList: {
                    popupDuzenleme: false,
                    popupDurumGuncelle: false,
                },
                sizes: 10,
                sizesTaslak: 10,
                page: 0,
                pageTaslak: 0,
                postPage: 0,
                postPageTaslak: 0,
                total: null,
                totalTaslak: null,
                dialogDetayVisible: false,
                deleteDialogVisible: false,
                addDialogVisible: false,
                selection: '',
                selectionIndex: '',
                popupListe: [],
            }
        },
        methods: {
            handleSizeChange(val) {
                this.sizes = val;
                this.getPopupListe();
            },
            pageChange(val) {
                this.postPage = (val - 1) * this.sizes;
                this.getPopupListe();
            },
            handleChange(event) {
                this.selectIcon = event;
                this.getPopupListe();
            },
            getPopupListe() {
                popupService.popListDetay(this.postPage, this.sizes, this.selectIcon).then(response => {
                    if (response.status === 200) {
                        this.popupListe = response.data;
                    } else {
                        notification.Status(response.status, this)
                    }
                });
            },
            changePopDurum(selection, index, durum) {
                popupService.popDurumGuncelle(selection.popKodu, durum).then((response) => {
                    if (response.status === 200) {
                        switch (durum) {
                            case '0':
                                this.popupListe.splice(index, 1);
                                notification.Status("success", this, "Popup taslağa taşındı.");
                                break;
                            case '1':
                                this.popupListe.splice(index, 1);
                                notification.Status("success", this, "Popup yayına alındı.");
                                break;
                        }
                    } else {
                        notification.Status(response.status, this)
                    }
                })
            },
            routePop(name, scope) {
                var tabList = this.$store.state.tabList;
                if (scope) {
                    this.$store.commit('changeUpdateKodu', scope.popKodu);
                }
                var header = linkTemizle(name.replace(" ", ""));
                var obj = tabList.find(data => data.title === name);
                if (obj === undefined) {
                    tabList.push({
                        title: name,
                        name: header,
                        contentName: header
                    });
                    this.$store.commit('changeTabList', tabList);
                    this.$store.commit('changeActiveTabs', header);
                } else {
                    this.$store.commit('changeActiveTabs', header);
                }
            },
        }
    }

    function linkTemizle(text) {
        var trMap = {
            'çÇ': 'c',
            'ğĞ': 'g',
            'şŞ': 's',
            'üÜ': 'u',
            'ıİ': 'i',
            'öÖ': 'o'
        };
        for (var key in trMap) {
            text = text.replace(new RegExp('[' + key + ']', 'g'), trMap[key]);
        }
        return text.replace(/[^-a-zA-Z0-9\s]+/ig, '')
            .replace(/\s/gi, "-")
            .replace(/[-]+/gi, "-")

    }
</script>


<style lang="scss" scoped>
    .el-pagination {
        margin-top: 20px;
        float: right;
    }

    .el-radio-button--mini .el-radio-button__inner label {
        position: relative;
        bottom: 5px;
    }

    .kaldirilmis {
        background: #ec205f;
        color: white;
        font-weight: bold;
        font-size: 16px;
        padding: 10px
    }

</style>
<style lang="scss">
    .slide-fade-enter-active {
        transition: all .3s ease;
    }


    @media (min-width: 768px) {
        .el-radio-button--mini .el-radio-button__inner {
            padding: 0 10px !important;
            font-size: 11px;
            border-radius: 0;
        }
    }


    .slide-fade-leave-active {
        transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }

    .slide-fade-enter, .slide-fade-leave-to
        /* .slide-fade-leave-active below version 2.1.8 */
    {
        transform: translateX(10px);
        opacity: 0;
    }
</style>